module.exports = __webpack_public_path__ + "static/media/visa.aa10fe6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/visa.svg
// module id = 861
// module chunks = 7